<script lang="ts">
  export let date: string = "";
  export let formatDate: boolean = true;
  
  let formattedDate = date;
  
  // If the user wants to format the date and we have a date string
  if (formatDate && date) {
    // For Finnish date format like "20.05.2025 12:49" or "20.05.2025"
    // We'll just use it directly, as it's already in a nice readable format
    if (date.match(/^\d{1,2}\.\d{1,2}\.\d{4}/)) {
      // It's already in Finnish format, use it as is or with minor formatting
      
      // Optional: Remove time component if present
      // formattedDate = date.split(' ')[0];
      
      // Use the date as provided - most natural for Finnish users
      formattedDate = date;
    } else {
      // For other formats, try to parse and format it
      try {
        const dateObj = new Date(date);
        
        // Check if date is valid
        if (!isNaN(dateObj.getTime())) {
          formattedDate = new Intl.DateTimeFormat('fi-FI', {
            year: 'numeric', 
            month: 'long', 
            day: 'numeric'
          }).format(dateObj);
        } else {
          formattedDate = date;
        }
      } catch (e) {
        console.error("Error formatting date", e);
        // Keep the original string if there's an error
        formattedDate = date;
      }
    }
  }
</script>

{#if formattedDate}
  <p class="event-date">{formattedDate}</p>
{/if}

<style lang="scss">
  .event-date {
    font-size: inherit;
	font-family: inherit;
	font-weight: inherit;
	color: inherit;
	letter-spacing: inherit;
	line-height: inherit;
	text-align: inherit;
  }
</style>